import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(quarterOfYear);

export const getStartDateOfQuarter = (quarter: number, year: number) =>
    dayjs().year(year).quarter(quarter).startOf('quarter').toDate();

export default dayjs;
